import serves from '@/api/axios'
// import qs from 'qs'
const defaultAxios = serves(process.env.VUE_APP_URL)

// 查询字典数据列表
export const listData = (body) => defaultAxios.get('system/dict/data/list', body)

// 查询字典数据详细
export const getData = (dictCode) => defaultAxios.get('system/dict/data/' + dictCode)

// 根据字典类型查询字典数据信息
export const getDicts = (dictType) => defaultAxios.get('system/dict/data/type/' + dictType)